import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { ResumoCotasUsuariosEmpreendimento } from "../interfaces/ResumoCotasUsuariosEmpreendimento";

export const buscarResumoCotasUsuariosEmpreendimentoService = async (
  empreendimentoId: number
) => {
  const token = validateToken();

  if (!token) {
    return null;
  }

  const url = `${Globais.DOMINIOBACK}/empreendimento/${empreendimentoId}/resumo-cotas-usuarios`;

  try {
    const response = await axios.get<ResumoCotasUsuariosEmpreendimento | null>(
      url,
      {
        headers: { Authorization: token.AuthStr },
      }
    );

    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
